import { Box, Checkbox, type SxProps } from "@mui/material";
import { BubbleCount } from "../../bubble-count";
import { DataTableCell } from "../data-table-cell";
import { CellDivider } from "../cell-divider";

export const DataTableCellCheckbox = ({
  onChange,
  disabled = false,
  checked = false,
  sx,
  count = null,
  shrink = false,
}: {
  onChange?: () => void;
  disabled?: boolean;
  checked?: boolean;
  sx?: SxProps;
  count?: number | null;
  shrink?: boolean;
}) => {
  return (
    <DataTableCell
      sx={{
        position: "relative",
        minWidth: "62px",
        pl: 0.32,
        maxWidth: "80px",
        ...sx,
      }}
      shrink={shrink}
    >
      <Box sx={{ textAlign: "center" }}>
        <Checkbox
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          size="small"
        />
      </Box>
      {count !== null && <BubbleCount count={count} offset="0.7rem" />}
      <CellDivider />
    </DataTableCell>
  );
};
